import PriorityHighIcon from "@mui/icons-material/PriorityHigh";

export const ResetPasswordErrorScreen = () => {
  return (
    <div className="flex flex-col w-full min-h-screen px-8 pl-36 justify-center">
      <div className="flex flex-col max-w-lg gap-8">
        <div className="bg-faux-medium-vermilion flex justify-center items-center rounded-full h-16 w-16 text-white">
          <PriorityHighIcon fontSize="large" />
        </div>
        <div>
          <h1 className="text-white text-3xl font-semibold font-orbitron">
            No pudimos enviar las instrucciones
          </h1>
          <p className="text-white text-xl font-inter">
            Por favor, Contacta a tu vendedor
          </p>
        </div>
      </div>
    </div>
  );
};
